import { ColumnConfig, ColumnConfigOptions, ColumnText, DateFormatter, MappedValueFormatter, SimplePortfolioExtractorConfig, StoreLodashExtractor, TabConfig } from '@ddt-web/data-service';
import { DateUtil } from '@ddt-web/generic-utils';

import { FAMILY_COLUMN_CONFIG } from './family-column.config';

export const FAMILIES_CONFIG = new TabConfig(
	'family.list',
	null,
	new SimplePortfolioExtractorConfig(
		null,
		[
			ColumnConfig.create({
				id: 'familyId',
				extractor: new StoreLodashExtractor(['families'], 'id'),
				visible: false
			} as ColumnConfigOptions<StoreLodashExtractor>),
			ColumnConfig.create({
				id: 'modelManager',
				extractor: new StoreLodashExtractor(['families'], 'modelManager')
			} as ColumnConfigOptions<StoreLodashExtractor>),
			ColumnConfig.create({
				id: 'preferences',
				extractor: new StoreLodashExtractor(['families'], 'preferences'),
				visible: false
			} as ColumnConfigOptions<StoreLodashExtractor>),
			ColumnConfig.create({
				id: 'openArchitecture',
				extractor: new StoreLodashExtractor(['families'], 'openArchitecture'),
				visible: false
			} as ColumnConfigOptions<StoreLodashExtractor>),
			ColumnConfig.create({
				id: 'subType',
				extractor: new StoreLodashExtractor(['families'], 'subType')
			} as ColumnConfigOptions<StoreLodashExtractor>),
			ColumnConfig.create({
				id: 'description',
				extractor: new StoreLodashExtractor(['families'], 'description')
			} as ColumnConfigOptions<StoreLodashExtractor>),
			ColumnConfig.create({
				label: new ColumnText('OBJECTIVE', 'Objective'),
				id: 'objective',
				extractor: new StoreLodashExtractor(['families'], 'marketingDescription')
			} as ColumnConfigOptions<StoreLodashExtractor>),
			ColumnConfig.create({
				id: 'modelCategoryType',
				extractor: new StoreLodashExtractor(['families'], 'modelCategoryType'),
				visible: false
			} as ColumnConfigOptions<StoreLodashExtractor>),
			ColumnConfig.create({
				label: new ColumnText('VEHICLE', 'Vehicle'),
				id: 'vehicle',
				extractor: new StoreLodashExtractor(['families'], 'vehicle'),
				labelFormatter: new MappedValueFormatter({
					'etf_&_mf': 'ETFs and MFs',
					'etf_only': 'ETF only',
					'mf_only': 'MF only'
				})
			} as ColumnConfigOptions<StoreLodashExtractor>),
			ColumnConfig.create({
				label: new ColumnText('TRADE_FREQUENCY', 'Trade Frequency'),
				id: 'tradeFrequency',
				extractor: new StoreLodashExtractor(['families'], 'tradeFrequency'),
				labelFormatter: new MappedValueFormatter({
					'dynamic_(4-8_trades_per_year)': 'Dynamic <br />(4-8 trades/year)',
					'dynamic_(4-6_trades_per_year)': 'Dynamic <br />(4-6 trades/year)',
					'tactical_(more_than_8_trades_per_year)': 'Tactical <br />(> 8 trades/year)',
					'strategic_(less_than_3_trades_per_year)': 'Strategic <br />(< 3 trades/year)',
					'dynamic_4-8_trades_per_year': 'Dynamic <br />(4-8 trades/year)',
					'dynamic_4-6_trades_per_year': 'Dynamic <br />(4-6 trades/year)',
					'tactical_more_than_8_trades_per_year': 'Tactical <br />(> 8 trades/year)',
					'strategic_less_than_3_trades_per_year': 'Strategic <br />(< 3 trades/year)'
				})
			} as ColumnConfigOptions<StoreLodashExtractor>),
			ColumnConfig.create({
				label: new ColumnText('LATEST_TRADE_DATE', 'Latest Trade Date'),
				id: 'asOfDate',
				extractor: new StoreLodashExtractor(['families'], 'asOfDate', ''),
				labelFormatter: new DateFormatter(DateUtil.MODELS_US_DATE_FORMAT, '')
			} as ColumnConfigOptions<StoreLodashExtractor>),
			ColumnConfig.create({
				id: 'portfolios',
				extractor: new StoreLodashExtractor(['families'], 'models')
			} as ColumnConfigOptions<StoreLodashExtractor>),
			ColumnConfig.create({
				id: 'displayOrder',
				extractor: new StoreLodashExtractor(['families'], 'displayOrder'),
				visible: false
			} as ColumnConfigOptions<StoreLodashExtractor>),
			ColumnConfig.create({
				id: 'aladdinTicker',
				extractor: new StoreLodashExtractor(['families'], 'aladdinTicker'),
				visible: false
			} as ColumnConfigOptions<StoreLodashExtractor>),
			ColumnConfig.create({
				id: 'modelExternalName',
				extractor: new StoreLodashExtractor(['families'], 'modelExternalName')
			} as ColumnConfig<StoreLodashExtractor>)
		],
		FAMILY_COLUMN_CONFIG
	)
);

export const FAMILIES_NAME_CONFIG = new TabConfig(
	'me.dropdown.family.list',
	null,
	new SimplePortfolioExtractorConfig(
		null,
		[
			ColumnConfig.create({
				id: 'familyId',
				extractor: new StoreLodashExtractor(['families'], 'id')
			} as ColumnConfigOptions<StoreLodashExtractor>),
			ColumnConfig.create({
				id: 'description',
				extractor: new StoreLodashExtractor(['families'], 'description')
			} as ColumnConfigOptions<StoreLodashExtractor>),
			ColumnConfig.create({
				id: 'displayOrder',
				extractor: new StoreLodashExtractor(['families'], 'displayOrder'),
				visible: false
			} as ColumnConfigOptions<StoreLodashExtractor>),
			ColumnConfig.create({
				id: 'subType',
				extractor: new StoreLodashExtractor(['families'], 'subType')
			} as ColumnConfigOptions<StoreLodashExtractor>),
			ColumnConfig.create({
				label: new ColumnText('LATEST_TRADE_DATE', 'Latest Trade Date'),
				id: 'asOfDate',
				extractor: new StoreLodashExtractor(['families'], 'asOfDate', ''),
				labelFormatter: new DateFormatter(DateUtil.MODELS_US_DATE_FORMAT, '')
			} as ColumnConfigOptions<StoreLodashExtractor>),
			ColumnConfig.create({
				label: new ColumnText('TRADE_FREQUENCY', 'Trade Frequency'),
				id: 'tradeFrequency',
				extractor: new StoreLodashExtractor(['families'], 'tradeFrequency'),
				labelFormatter: new MappedValueFormatter({
					'dynamic_(4-8_trades_per_year)': 'Dynamic <br />(4-8 trades/year)',
					'dynamic_(4-6_trades_per_year)': 'Dynamic <br />(4-6 trades/year)',
					'tactical_(more_than_8_trades_per_year)': 'Tactical <br />(> 8 trades/year)',
					'strategic_(less_than_3_trades_per_year)': 'Strategic <br />(< 3 trades/year)',
					'dynamic_4-8_trades_per_year': 'Dynamic <br />(4-8 trades/year)',
					'dynamic_4-6_trades_per_year': 'Dynamic <br />(4-6 trades/year)',
					'tactical_more_than_8_trades_per_year': 'Tactical <br />(> 8 trades/year)',
					'strategic_less_than_3_trades_per_year': 'Strategic <br />(< 3 trades/year)'
				})
			} as ColumnConfigOptions<StoreLodashExtractor>),
			ColumnConfig.create({
				id: 'modelExternalName',
				extractor: new StoreLodashExtractor(['families'], 'modelExternalName')
			} as ColumnConfigOptions<StoreLodashExtractor>)
		],
		FAMILY_COLUMN_CONFIG
	)
);
